const C = require("../constants");

const openModalRecipesProductsPreMake = modal => {
    return {
        type: C.OPEN_MODAL_RECIPES_PRODUCTS_PRE_MAKE,
        modal
    }
};

export {openModalRecipesProductsPreMake};


// WEBPACK FOOTER //
// ./src/actions/ModalRecipeProductsPreMakeActions.js